export default __webpack_public_path__ + "c8dc04eb6ea61bd75a01b99b47bb0df5.svg";